import './history-attendances.scss';
import template from './history-attendances.html';

class HistoryAttendancesComponent {
  /** @ngInject */
  constructor(
    $rootScope, $log, $interval, $mdSidenav, $mdDialog, $mdToast, moment,
    StudentService
  ) {
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$interval = $interval;
    this.$mdSidenav = $mdSidenav;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.StudentService = StudentService;

    this.attendances = [];
  }

  $onInit() {
    this.loadHistoryAttendances();
    this.historyAttendancesInterval = this.$interval(() => {
      this.loadHistoryAttendances({showLoaderSpinner: false});
    }, 180000);

    this.$rootScope.$on('component.dashboard.close-attendance', () => {
      this.loadHistoryAttendances({showLoaderSpinner: false});
    });
  }

  $onChanges(changes) {
    if (changes.groups) {
      this.groups = {...this.groups};
    }
  }

  $onDestroy() {
    this.$interval.cancel(this.historyAttendancesInterval);
  }

  toggleHistoryAttendances() {
    this.$mdSidenav('history-attendances')
      .toggle();
  }

  loadHistoryAttendances(options = {}) {
    let id = options.groupId;
    if (angular.isDefined(this.selectedGroupId) && this.selectedGroupId > 0) {
      id = this.selectedGroupId;
    }

    options.date = this.moment().format('YYYY-MM-DD');
    this.StudentService.getAttendances({
      groupId: id,
      day: options.date,
      showLoaderSpinner: options.showLoaderSpinner
    }).then(result => {
      this.attendances = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać tablicy wyjść')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}

export const HistoryAttendances = {
  bindings: {
    groups: '<'
  },
  template,
  controller: HistoryAttendancesComponent
};
